module.exports = __webpack_public_path__ + "static/media/fiverr.26c0edbe.png";